import { render, staticRenderFns } from "./freestylelibre-details.vue?vue&type=template&id=50a3f311"
import script from "./freestylelibre-details.vue?vue&type=script&lang=js"
export * from "./freestylelibre-details.vue?vue&type=script&lang=js"
import style0 from "./freestylelibre-details.vue?vue&type=style&index=0&id=50a3f311&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports